module.exports = __webpack_public_path__ + "img/truck.776ac10c.svg";